import { useContext } from 'react'
import RootStore from '~/stores/RootStore'
import theme from '~/theme/default'
import StyledIcon from './StyledIcon'
import { observer } from 'mobx-react-lite'
import AnimatedBox from './Motion/AnimatedBox'
import { AnimatePresence } from 'motion/react'
import zIndexes from '../theme/zIndexes'
import { useLocation } from 'react-router'
import { Theme, SxProps } from '@mui/material'
import { EnterPreset } from './Motion/animationPresets'

interface Props {
  sx?: SxProps<Theme>
  animation?: EnterPreset[]
  size?: number
}

export const RefreshIconInner = ({ sx, animation, size = 28 }: Props) => {
  return (
    <AnimatedBox
      layout
      sx={{
        zIndex: zIndexes.loadingIndicator,
        bgcolor: 'background.paper',
        p: theme.spacing(1),
        display: 'flex',
        alignItems: 'center',
        ...sx,
      }}
      entering={animation ?? ['fade', 'right']}
      exiting={animation ?? ['fade', 'right']}
    >
      <AnimatedBox
        animate={{ rotate: 360 }}
        transition={{ duration: 1.5, repeat: Infinity, ease: 'linear' }}
      >
        <StyledIcon
          name='loadingSpinner'
          size={size}
          color='primary'
          sx={{ display: 'block' }}
        />
      </AnimatedBox>
    </AnimatedBox>
  )
}

function RefreshIcon() {
  const store = useContext(RootStore)
  const { activeRequests } = store.uiStore
  const location = useLocation()
  const isVisible = activeRequests.length > 0 && location.pathname !== '/calendar'

  return (
    <AnimatePresence>
      {isVisible && <RefreshIconInner
        sx={{
          bottom: theme.spacing(3),
          right: theme.spacing(3),
          position: 'fixed',
          borderRadius: theme.spacing(10),
          border: `1px solid ${theme.palette.secondary.main}`,
        }}
      />}
    </AnimatePresence>
  )
}

export default observer(RefreshIcon)